import { render, staticRenderFns } from "./wsSlider.vue?vue&type=template&id=3e131763&scoped=true&"
import script from "./wsSlider.vue?vue&type=script&lang=js&"
export * from "./wsSlider.vue?vue&type=script&lang=js&"
import style0 from "./wsSlider.vue?vue&type=style&index=0&id=3e131763&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e131763",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VIcon,VImg,VSheet})
